import { animated } from 'react-spring';
import styled from 'styled-components';

export const Container = styled(animated.aside)`
  background: #6a49d9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0rem;
  height: 100vh;
  width: 70%;
  padding: 1.2rem 1rem;
  max-width: 350px;
  z-index: 10;
`;

export const Nav = styled(animated.nav)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  position: relative;

  .hr {
    border-top: 2px solid rgba(255, 255, 255, 0.2);
    width: 100%;
  }

  ul {
    width: 100%;
    flex: 1;
  }

  .close {
    position: absolute;
    top: -19px;
    right: -1rem;
    background: #5e3eca;
    border: 0;
  }

  .toggleTheme {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    p {
      margin-left: 0.5rem;
      color: #fff;
    }
  }

  .signOutButton {
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    border: 0;

    p {
      margin-left: 0.5rem;
      color: #fff;
    }
  }
`;

export const Li = styled(animated.li)`
  list-style: none;

  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    margin-bottom: 1.5rem;

    > div {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 0.5rem;
      }
    }
  }
`;

export const Header = styled(animated.header)`
  display: flex;
  align-items: center;

  img {
    margin-right: 1rem;
    border-radius: 50%;
  }

  p {
    color: #fff;
    font-weight: 600;
  }
`;
